import { ChallengeSolution } from './components/ChallengeSolution'
import { Contact } from './components/Contact'
import { EmploymentTalent } from './components/EmploymentTalent'
import { Faq } from './components/Faq'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { ProofBand } from './components/ProofBand'
import { QualityProcess } from './components/QualityProcess'
import { SouthAfrica } from './components/SouthAfrica'
import { PrivacyPage } from './pages/PrivacyPage'
import { ProfessionalsPage } from './pages/ProfessionalsPage'
import { useRevealAnimations } from './hooks/useRevealAnimations'
import { usePageMetadata } from './hooks/usePageMetadata'

function FirmsPage() {
  useRevealAnimations()
  usePageMetadata({
    title: 'Ark Solutions | South African finance talent for global firms',
    description: 'Ark Solutions sources, employs and supports qualified South African finance professionals for international accounting and audit firms.',
    canonicalPath: '/',
  })

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="site-shell" id="top">
        <Header />
        <Hero />
      </div>
      <main id="main">
        <ProofBand />
        <ChallengeSolution />
        <QualityProcess />
        <SouthAfrica />
        <EmploymentTalent />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>
  )
}

export default function App() {
  const path = window.location.pathname.replace(/\/$/, '') || '/'

  if (path === '/for-professionals') return <ProfessionalsPage />
  if (path === '/privacy') return <PrivacyPage />
  return <FirmsPage />
}
